import { render, staticRenderFns } from "./SummaryOrder.vue?vue&type=template&id=430e5242&scoped=true"
import script from "./SummaryOrder.vue?vue&type=script&lang=js"
export * from "./SummaryOrder.vue?vue&type=script&lang=js"
import style1 from "./SummaryOrder.vue?vue&type=style&index=1&id=430e5242&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430e5242",
  null
  
)

export default component.exports